import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    btn: {
        height: '100%',
    },
    icon: {
        fill: theme.palette.secondary.main,
        width: 24,
        height: 24,
        marginRight: 8
    },
    title: {
        fontWeight: 500,
    }
}))